import { PaymentGuideStepper } from './PaymentGuideStepper';
import { PaymentGuideType } from './PaymentGuideType';

export const bogotaRefinanceSteps: PaymentGuideStepper[] = [
  {
    type: PaymentGuideType.AVAL_PAY_CENTER,
    steps: [
      { text: '1. Ingresa a Aval Pay Center a la cuenta Recaudo Acuerdo De Pago Banco Bogotá (Link: [https://www.avalpaycenter.com/wps/portal/portal-de-pagos.)](https://www.avalpaycenter.com/wps/portal/portal-de-pagos.))' },
      { text: '2. En la búsqueda para pagos escribir la palabra "TARJETA VISA ó TARJETA MASTER".' },
      { text: '3. Escoger la opción "**Banco De Bogotá - Tarjeta De Crédito Mastercard**” ó “**Banco De Bogotá - Tarjeta De Crédito Visa”**' },
      { text: '4. Ingresa tus datos:' },
      { indents: 1, text: '**a. Pago Tarjeta de Crédito:** Se deben ingresar los 16 dígitos de la tarjeta.' },
      { indents: 1, text: '**b.** Seleccionar el tipo de documento.' },
      { indents: 1, text: '**c.** Digitar tu número de cédula, sin comas ni puntos.' },
      { indents: 1, text: '**d.** Ingresa el valor exacto del abono a pagar.                                                                  ' },
      { indents: 1, text: '**e.** Acepta términos y condiciones.' },
      { indents: 1, text: '**f.**  Da click en el botón "Pagar".' },
      { indents: 1, text: '**g.** Continuar los pasos para pago PSE, ingresando los datos del titular del producto de donde saldrá el dinero y realiza la pasarela de pagos.' },
    ],
  },
  {
    type: PaymentGuideType.PHYSICAL,
    steps: [
      { text: '1. Solicitar formato de consignación.' },
      { text: '2. Diligenciar el número completo de la obligación a normalizar y demás datos del pago' },
      { text: '3. Hacer pago en caja.' },
    ],
  },
];
